// extracted by mini-css-extract-plugin
export default {"card":"uqYhv","card-title":"drDPr","card-description":"Ch1wr","card-button":"rZVXs"};